import React from 'react';
import { connect } from 'react-redux';
import Address from 'components/address';

class LocationInput extends Address {
  constructor(props) {
    super(props);
    this.inputEle = 'header-address-input';
  }
  geolocate() {}

  render() {
    return (
      <input
        id="header-address-input"
        placeholder="Enter a delivery address"
        defaultValue={this.props.defaultValue}
      />
    );
  }
}

function mapStateToProps(state) {
  return { ...state.address };
}

export default connect(mapStateToProps)(LocationInput);



// WEBPACK FOOTER //
// ./shared/components/header/addressInput.js